export const browserTranslate = {
    isSupported: false,
    isEnabled: () => false,
    observeTranslate: (cb: (isEnabled: boolean) => void) => {},
    disconnect: (cb: (isEnabled: boolean) => void) => {},
};
